<template>
  <div>
    <div class="bold-text">Aliments</div>
      <b-card>
        <b-form-checkbox-group
          class="checkbox-group"
          v-model="selectedFoods"
          :options="foodsOptions"
          name="selected-foods"
          size="lg"
          stacked
        ></b-form-checkbox-group>
      </b-card>
  </div>
</template>

<script>
export default {

  name: "FoodSelection",

  props: {

    foods: {
      type: Array,
      required: true
    },

    initSelectedFoods: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      selectedFoods: []
    }
  },

  mounted() {
    if (this.initSelectedFoods) {
      this.selectedFoods = this.initSelectedFoods
    }
  },

  watch: {
    'selectedFoods': function (newValue, oldValue) {
      this.$emit('didChangeSelectedFoods', this.selectedFoods)
    }
  },

  computed: {
    foodsOptions() {
      return this.foods.map(food => ({
          value: food.id,
          text: food.name
        }))
    }
  }
}
</script>

<style scoped>

@media (min-width: 576px) {
  .checkbox-group {
    column-count: 2;
  }
}

@media (min-width: 768px) {
  .checkbox-group {
    column-count: 3;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/food/FoodSelection.vue